<div class="row mt-2">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header bg-white text-center">
        <ul
          *ngIf="app.permission.businessConfig.seeWarehouseGroupSection"
          class="nav nav-tabs card-header-tabs"
        >
          <li class="nav-item">
            <a
              class="nav-link pointer-link"
              role="button"
              [ngClass]="{ active: viewType === 'warehouse-group' }"
              (click)="viewType = 'warehouse-group'"
              ><i class="fa-regular fa-warehouse"></i>&nbsp;
              {{ app.text.businessConfig.warehouseGroup }}</a
            >
          </li>
          <li
            *ngIf="
              app.permission.businessConfig.seeProcessesSection ||
              app.users.currentUser.businessManager
            "
            class="nav-item"
          >
            <a
              class="nav-link pointer-link"
              role="button"
              [ngClass]="{ active: viewType === 'processes' }"
              (click)="viewType = 'processes'"
              ><i class="fa-regular fa-gear"></i>&nbsp;
              {{ app.text.businessConfig.processes }}</a
            >
          </li>
        </ul>
      </div>
      <div class="card-body">
        <div class="row">
          <div [ngSwitch]="viewType">
            <!-- Warehouse Groups -->
            <div *ngIf="app.permission.businessConfig.seeWarehouseGroupSection">
              <div *ngSwitchCase="'warehouse-group'">
                <small class="text-muted"
                  ><i class="fa fa-info-circle"></i>&nbsp;
                  <span
                    [innerHtml]="
                      app.text.businessConfig.warehouseGroupDescription
                    "
                  ></span>
                </small>
                <app-warehouse-group> </app-warehouse-group>
              </div>
            </div>
            <!-- Processes -->
            <div
              *ngIf="
                app.permission.businessConfig.seeProcessesSection ||
                app.users.currentUser.businessManager
              "
            >
              <div *ngSwitchCase="'processes'">
                <div class="mb-3">
                  <small class="text-muted"
                    ><i class="fa fa-info-circle"></i>&nbsp;
                    <span
                      [innerHtml]="app.text.businessConfig.processesDescription"
                    ></span
                  ></small>
                </div>

                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm float-right"
                  (click)="app.businessConfig.runWarehousePartsUpdate()"
                >
                  <i class="fa fa-play-circle"></i>&nbsp;
                  {{ app.text.operations.run }}
                  {{ app.text.businessConfig.warehousePartsUpdate }}
                </button>

                <div>
                  <app-paginator
                    [length]="app.businessConfig.history.length"
                    [index]="app.paginator.focus"
                    (focus)="app.paginator.focus = $event"
                  ></app-paginator>

                  <div class="tableFixHead">
                    <table class="table table-striped spacing-table">
                      <thead>
                        <tr>
                          <th
                            class="table-header"
                            *ngFor="let column of getProcessesColumns()"
                          >
                            <span class="pointer">{{
                              app.field.getLabel("operations." + column)
                            }}</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="
                            let item of app.paginator.getPage(
                              app.businessConfig.history
                            )
                          "
                        >
                          <td
                            class="p-1"
                            *ngFor="let column of getProcessesColumns()"
                          >
                            <span
                              *ngIf="
                                column === 'create_time' ||
                                column === 'complete_time'
                              "
                            >
                              {{ item[column] | date : "yyyy-MM-dd HH:mm:ss" }}
                            </span>
                            <span *ngIf="column === 'work_type'">
                              {{ app.businessConfig.getTypeText(item[column]) }}
                            </span>
                            <span *ngIf="column === 'work_log'">
                              <button
                                type="button"
                                class="btn btn-link p-0"
                                (click)="downloadLog(item)"
                              >
                                <i class="fa fa-file-download"></i>
                              </button>
                            </span>
                            <span
                              *ngIf="!app.operations.isSpecialColumn(column)"
                            >
                              {{ item[column] }}
                            </span>
                          </td>
                        </tr>
                        <tr *ngIf="app.businessConfig.history.length === 0">
                          <td colspan="99" class="p-1 text-center">
                            {{ app.text.businessConfig.noHistoryAvailable }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
